import type { InputProps } from '@byecode/ui'
import { Flex, Input } from '@byecode/ui'
import { ListItem4ByecodeUi } from '@lighthouse/shared'
import React from 'react'
import styled from 'styled-components'

interface InputControlProps extends Omit<InputProps, 'onChange'> {
    label: string
    value?: string | number
    placeholder?: string
    tipNode?: React.ReactNode
    onChange?: (value: string) => void
}

export const InputControl = React.forwardRef<HTMLDivElement, InputControlProps>(({ label, tipNode, onChange, ...rest }, ref) => {
    return (
        <ListItem4ByecodeUi ref={ref} alignItems="center" justifyContent="space-between">
            <Flex alignItems="center" gap={6}>
                {label}
                {tipNode}
            </Flex>
            <Input style={{ width: 180 }} {...rest} onChange={e => onChange?.(e.target.value)} />
        </ListItem4ByecodeUi>
    )
})
